"use strict";

var _objectSpread = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashDomain = exports.hashTypedData = void 0;
const encodeAbiParameters_js_1 = require("../abi/encodeAbiParameters.js");
const concat_js_1 = require("../data/concat.js");
const toHex_js_1 = require("../encoding/toHex.js");
const keccak256_js_1 = require("../hash/keccak256.js");
const typedData_js_1 = require("../typedData.js");
function hashTypedData(_ref) {
  let {
    domain: domain_,
    message,
    primaryType,
    types: types_
  } = _ref;
  const domain = typeof domain_ === 'undefined' ? {} : domain_;
  const types = _objectSpread({
    EIP712Domain: (0, typedData_js_1.getTypesForEIP712Domain)({
      domain
    })
  }, types_);
  (0, typedData_js_1.validateTypedData)({
    domain,
    message,
    primaryType,
    types
  });
  const parts = ['0x1901'];
  if (domain) parts.push(hashDomain({
    domain,
    types: types
  }));
  if (primaryType !== 'EIP712Domain') {
    parts.push(hashStruct({
      data: message,
      primaryType: primaryType,
      types: types
    }));
  }
  return (0, keccak256_js_1.keccak256)((0, concat_js_1.concat)(parts));
}
exports.hashTypedData = hashTypedData;
function hashDomain(_ref2) {
  let {
    domain,
    types
  } = _ref2;
  return hashStruct({
    data: domain,
    primaryType: 'EIP712Domain',
    types
  });
}
exports.hashDomain = hashDomain;
function hashStruct(_ref3) {
  let {
    data,
    primaryType,
    types
  } = _ref3;
  const encoded = encodeData({
    data,
    primaryType,
    types
  });
  return (0, keccak256_js_1.keccak256)(encoded);
}
function encodeData(_ref4) {
  let {
    data,
    primaryType,
    types
  } = _ref4;
  const encodedTypes = [{
    type: 'bytes32'
  }];
  const encodedValues = [hashType({
    primaryType,
    types
  })];
  for (const field of types[primaryType]) {
    const [type, value] = encodeField({
      types,
      name: field.name,
      type: field.type,
      value: data[field.name]
    });
    encodedTypes.push(type);
    encodedValues.push(value);
  }
  return (0, encodeAbiParameters_js_1.encodeAbiParameters)(encodedTypes, encodedValues);
}
function hashType(_ref5) {
  let {
    primaryType,
    types
  } = _ref5;
  const encodedHashType = (0, toHex_js_1.toHex)(encodeType({
    primaryType,
    types
  }));
  return (0, keccak256_js_1.keccak256)(encodedHashType);
}
function encodeType(_ref6) {
  let {
    primaryType,
    types
  } = _ref6;
  let result = '';
  const unsortedDeps = findTypeDependencies({
    primaryType,
    types
  });
  unsortedDeps.delete(primaryType);
  const deps = [primaryType, ...Array.from(unsortedDeps).sort()];
  for (const type of deps) {
    result += "".concat(type, "(").concat(types[type].map(_ref7 => {
      let {
        name,
        type: t
      } = _ref7;
      return "".concat(t, " ").concat(name);
    }).join(','), ")");
  }
  return result;
}
function findTypeDependencies(_ref8) {
  let {
    primaryType: primaryType_,
    types
  } = _ref8;
  let results = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
  const match = primaryType_.match(/^[0-9A-Z_a-z]*/);
  const primaryType = match === null || match === void 0 ? void 0 : match[0];
  if (results.has(primaryType) || types[primaryType] === undefined) {
    return results;
  }
  results.add(primaryType);
  for (const field of types[primaryType]) {
    findTypeDependencies({
      primaryType: field.type,
      types
    }, results);
  }
  return results;
}
function encodeField(_ref9) {
  let {
    types,
    name,
    type,
    value
  } = _ref9;
  if (types[type] !== undefined) {
    return [{
      type: 'bytes32'
    }, (0, keccak256_js_1.keccak256)(encodeData({
      data: value,
      primaryType: type,
      types
    }))];
  }
  if (type === 'bytes') {
    const prepend = value.length % 2 ? '0' : '';
    value = "0x".concat(prepend + value.slice(2));
    return [{
      type: 'bytes32'
    }, (0, keccak256_js_1.keccak256)(value)];
  }
  if (type === 'string') return [{
    type: 'bytes32'
  }, (0, keccak256_js_1.keccak256)((0, toHex_js_1.toHex)(value))];
  if (type.lastIndexOf(']') === type.length - 1) {
    const parsedType = type.slice(0, type.lastIndexOf('['));
    const typeValuePairs = value.map(item => encodeField({
      name,
      type: parsedType,
      types,
      value: item
    }));
    return [{
      type: 'bytes32'
    }, (0, keccak256_js_1.keccak256)((0, encodeAbiParameters_js_1.encodeAbiParameters)(typeValuePairs.map(_ref10 => {
      let [t] = _ref10;
      return t;
    }), typeValuePairs.map(_ref11 => {
      let [, v] = _ref11;
      return v;
    })))];
  }
  return [{
    type
  }, value];
}
//# sourceMappingURL=hashTypedData.js.map